import { ListFilter } from 'lucide-react';
import type { ReactNode } from 'react';
import { Button, type ButtonProps } from './Button';
import Pill from './Pill';

interface FilterButtonProps extends Omit<ButtonProps, 'children' | 'size' | 'variant'> {
  count?: number;
  label?: ReactNode;
}

const FilterButton = ({ count = 0, label, ...props }: FilterButtonProps) => {
  return (
    <Button variant="outline" size="filter" aria-label="Filter" {...props}>
      <ListFilter size={16} strokeWidth={1.5} className="text-foreground" />
      {label}
      {count > 0 && (
        <Pill
          variant="soft"
          color="destructive"
          className="absolute -right-[5px] -top-[5px] h-[14px] w-[14px] justify-center p-0 text-[10px] leading-none"
        >
          {count}
        </Pill>
      )}
    </Button>
  );
};

export default FilterButton;
